import { render, staticRenderFns } from "./BusDocuments.vue?vue&type=template&id=5f0a4eca&scoped=true"
import script from "./BusDocuments.vue?vue&type=script&lang=js"
export * from "./BusDocuments.vue?vue&type=script&lang=js"
import style0 from "./BusDocuments.vue?vue&type=style&index=0&id=5f0a4eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a4eca",
  null
  
)

export default component.exports